import { jsx as _jsx } from "react/jsx-runtime";
import UserProfile from '../../../components/UserProfile';
import { useAchievementUser } from '../achievementQueries';

const AchievementUserProfile = ({
  publicId
}) => {
  const user = useAchievementUser(publicId);
  if (!user) return null;
  return /*#__PURE__*/_jsx(UserProfile, {
    avatarHash: user.avatarHash,
    connectUserId: user.userId,
    firstName: user.firstName,
    lastName: user.lastName
  });
};

export default AchievementUserProfile;